<template>
  <div class="HeaderFinalizarImportacao">
    <div class="radioBox">
      <svg class="radioBox_icon icon--lg"
           role="presentation">                   
        <use :xlink:href="'#' + type.icon.id" />
      </svg>

      <div v-if="livro.tipo_livro !== 'CR'">
        <span class="radioBox_title w-100 d-inline-block">
          {{ type.text }}
        </span>
      </div>

      <div v-else>
        <span class="radioBox_preTitle w-100 d-inline-block small">
          {{ type.preText }}
        </span>

        <span class="radioBox_titleReligioso w-100 d-inline-block small">
          {{ type.text }}
        </span>
      </div>
    </div>

    <b-card class="mb-4 card">
      <div class="row">
        <p class="col-12 col-sm-5 text-left mr-0 pr-0">
          <strong>Livro:</strong> {{ livro.num_livro }}
        </p>

        <p class="col-12 col-sm-4 text-left ml-0 mr-0 pr-0">
          <strong>1.º termo:</strong> {{ livro.primeiro_termo }}
        </p>

        <p class="col-12 col-sm-3 text-right pl-0">
          <strong>Qtd registros:</strong> {{ livro.registros.length }}
        </p>
      </div>

      <div class="row">
        <p class="col-12 col-sm-5 text-left mr-0 pr-0">
          <strong>Acervo:</strong> {{ livro.acervo }}
        </p>

        <p class="col-12 col-sm-3 text-left ml-0 mr-0 pr-0">
          <strong>Último termo:</strong> {{ livro.ultimo_termo }}
        </p>

        <p v-if="livro.total_faltantes_show">
          <strong>Registros faltantes:</strong> {{ livro.total_faltantes_show }} de {{ livro.total_faltantes }}
        </p>
      </div>

      <div v-if="origem === 'REGISTRO'">
        <div class="row">
          <p class="col-12 col-sm-5 text-left mr-0 pr-0">
            <strong>Data do registro:</strong> {{ dataRegistroInit }} até {{ dataRegistroFim }}
          </p>

          <p class="col-12 col-sm-5 text-left mr-0 pr-0">
            <strong>Data do ocorrido:</strong> {{ dataOcorridoInit }} até {{ dataOcorridoFim }}
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-5 text-left mr-0 pr-0">
            <strong>Registro inicial:</strong> {{ livro.primeiro_termo }}
          </p>

          <p class="col-12 col-sm-5 text-left mr-0 pr-0">
            <strong>Registro final:</strong> {{ livro.ultimo_termo }}
          </p>
        </div>

        <div class="row">
          <p v-if="livro.total_duplicado_show"
             class="col-6 col-sm-6 text-left">
            <strong>Registros duplicados:</strong> {{ livro.total_duplicado_show }} de {{ livro.total_duplicado }}
          </p>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
  import moment from 'moment'

  // SVGs
  import obito from '@/assets/icons/flower.svg?sprite'
  import nasc from '@/assets/icons/baby-buggy.svg?sprite'
  import natimorto from '@/assets/icons/ribbon.svg?sprite'
  import casamento from '@/assets/icons/engagement.svg?sprite'
  import casamentoRegilioso from '@/assets/icons/calendar-heart.svg?sprite'
  
  export default {
    name: 'HeaderFinalizarImportacao',
    props: {
      livro: {
        type: Object,
        default: () => {}
      },
      origem: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        typeList: [
          {
            text: 'Nascimento',
            id: 1,
            valor: 'N',
            icon: nasc
          },
          {
            text: 'Casamento',
            id: 2,
            valor: 'C',
            icon: casamento
          },
          {
            preText: 'Casamento',
            text: 'Religioso',
            id: 3,
            valor: 'CR',
            icon: casamentoRegilioso
          },
          {
            text: 'Óbito',
            id: 4,
            valor: 'O',
            icon: obito
          },
          {
            text: 'Natimorto',
            id: 5,
            valor: 'NT',
            icon: natimorto
          }
        ],
        type: null,
        dataRegistroInit: null,
        dataRegistroFim: null,
        dataOcorridoInit: null,
        dataOcorridoFim: null
      }
    },
    beforeMount () {
      this.type = this.typeList.find(type => type.valor === this.livro.tipo_livro)

      if (!this.origem) return 

      if (this.origem === 'REGISTRO') {
        this.dataRegistroInit = moment(this.livro.registros[0].data_registro).format('DD/MM/YYYY'),
        this.dataRegistroFim = moment(this.livro.registros[this.livro.registros.length - 1].data_registro).format('DD/MM/YYYY'),
        this.dataOcorridoInit = moment(this.livro.registros[0].data_ocorrido).format('DD/MM/YYYY'),
        this.dataOcorridoFim = moment(this.livro.registros[this.livro.registros.length - 1].data_ocorrido).format('DD/MM/YYYY')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';
  
  .radioBox {
    border: pxToRem(1) solid $color-gray-light;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;
    background-color: $color-logo;
    border-color: $color-logo;

    &_icon {
      margin-top: 0.3rem;
      fill: $color-white;
      margin-left: 30%;
    }

    &_title {
      color: $color-white;
      font-size: pxToRem(15);
      font-weight: 500;
      transition: color 0.15s linear;
      text-align: center;
      margin-top: 5%;
    }

    &_preTitle {
      color: $color-white;
      font-size: pxToRem(14);
      font-weight: 400;
      transition: color 0.15s linear;
      text-align: center;
    }

    &_titleReligioso {
      color: $color-white;
      font-size: pxToRem(15);
      font-weight: 500;
      transition: color 0.15s linear;
      text-align: center;
    }
  }

  .card {
    border-style: solid;
    border-color: $color-logo;
    border-width: 4px;
    border-radius: 1px;

    .card-body {
      padding-bottom: 0;
    }
  }
</style>
